module.exports = __webpack_public_path__ + "img/2X.1.dba126b4.jpg";